{
  "font-face.css": "css/v1/font-face.05a7ed4c.css",
  "tokens.css": "css/v1/tokens.a3299985.css",
  "styles.css": "css/v1/styles.831ef042.css",
  "styles_md.css": "css/v1/styles_md.ff85772e.css",
  "styles_xl.css": "css/v1/styles_xl.477cb2f4.css",
  "styles_hover.css": "css/v1/styles_hover.3fbd1ade.css"
}